import { render, staticRenderFns } from "./operationsupdown.vue?vue&type=template&id=58da137c"
import script from "./operationsupdown.vue?vue&type=script&lang=js"
export * from "./operationsupdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports